import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)


// 中文
import Home from '../views/zh/index.vue'
import immigration from '../views/zh/immigration.vue'
import goodNews from '../views/zh/goodNews.vue'
import goodNewsDetail from '../views/zh/goodNewsDetail.vue'
import video from '../views/zh/video.vue'
import contactUs from '../views/zh/contactUs.vue'
import evaluate from '../views/zh/evaluate.vue'
import evaluateEoi from '../views/zh/evaluateEoi.vue'
import evaluateMaster from '../views/zh/evaluateMaster.vue'
import evaluateSmallStudent from '../views/zh/evaluateSmallStudent.vue'
import evaluateStudent from '../views/zh/evaluateStudent.vue'
import zh from '../views/zh/zh.vue'
import toursDetail from '../views/zh/toursDetail.vue'
import diary from '../views/zh/diary.vue'
import news from '../views/zh/new.vue'
import newsDetail from '../views/zh/newsDetail.vue'
import diaryDetail from '../views/zh/diaryDetail.vue'
import bossDetail from '../views/zh/boss.vue'
import spouse from '../views/zh/spouse.vue'

// 英文

import enHome from '../views/en/index.vue'
import enimmigration from '../views/en/immigration.vue'
import engoodNews from '../views/en/goodNews.vue'
import engoodNewsDetail from '../views/en/goodNewsDetail.vue'
import envideo from '../views/en/video.vue'
import encontactUs from '../views/en/contactUs.vue'
import enevaluate from '../views/en/evaluate.vue'
import enevaluateEoi from '../views/en/evaluateEoi.vue'
import enevaluateMaster from '../views/en/evaluateMaster.vue'
import enevaluateSmallStudent from '../views/en/evaluateSmallStudent.vue'
import enevaluateStudent from '../views/en/evaluateStudent.vue'
import en from '../views/en/en.vue'
import entoursDetail from '../views/en/toursDetail.vue'
import endiary from '../views/en/diary.vue'
import ennews from '../views/en/new.vue'
import ennewsDetail from '../views/en/newsDetail.vue'
import endiaryDetail from '../views/en/diaryDetail.vue'
import enbossDetail from '../views/en/boss.vue'
import enspouse from '../views/en/spouse.vue'


import infoDetail from '../views/zh/infoDetail.vue'


const router = new Router({
	routes: [{
		path: '/',
		name: 'Home',
		redirect: '/zh/index'
	},
	{
		path: '/zh',// 中文
		name: 'zh',
		component: zh,
		children: [
			{
				path: "index",// 首页
				name: "Home",
				component: Home,
			},
			{
				path: 'spouse',
				name: 'spouse',
				component: spouse
			},
			{
				path: "news",// 新闻
				name: "news",
				component: news,
			},
			{
				path: "newsDetail",// 新闻
				name: "newsDetail",
				component: newsDetail,
			}, {
				path: "immigration",// 移民服务
				name: "immigration",
				component: immigration,
			}, {
				path: "goodNews",// 喜报
				name: "goodNews",
				component: goodNews,
			}, {
				path: "goodNewsDetail",// 喜报详情
				name: "goodNewsDetail",
				component: goodNewsDetail,
			}, {
				path: "video",// 视频
				name: "video",
				component: video,
			}, {
				path: "contactUs",// 联系我们
				name: "contactUs",
				component: contactUs,
			}, {
				path: "evaluate",// 评估-配偶测评
				name: "evaluate",
				component: evaluate,
			}, {
				path: "evaluateEoi",// 评估-eoi测评
				name: "evaluateEoi",
				component: evaluateEoi,
			}, {
				path: "evaluateMaster",// 评估-雇主担保测评
				name: "evaluateMaster",
				component: evaluateMaster,
			}, {
				path: "evaluateSmallStudent",// 评估-中小学留学测评
				name: "evaluateSmallStudent",
				component: evaluateSmallStudent,
			}, {
				path: "evaluateStudent",// 评估-留学测评
				name: "evaluateStudent",
				component: evaluateStudent,
			},
			{
				path: "bossDetail",// 人才招聘详情
				name: "bossDetail",
				component: bossDetail,
			},


			{
				path: "toursDetail",// 游览详情
				name: "toursDetail",
				component: toursDetail,
			}, {
				path: "diary",// 旅游日记
				name: "diary",
				component: diary,
			}, {
				path: "diaryDetail",// 旅游日记详情
				name: "diaryDetail",
				component: diaryDetail,
			},]
	},
	{
		path: '/en',// 英文
		name: 'en',
		component: en,
		children: [
			{
				path: "index",// 首页
				name: "Home",
				component: enHome,
			}, {
				path: 'spouse',
				name: 'spouse',
				component: enspouse
			},
			{
				path: "news",// 新闻
				name: "news",
				component: ennews,
			},
			{
				path: "newsDetail",// 新闻
				name: "newsDetail",
				component: ennewsDetail,
			}, {
				path: "immigration",// 移民服务
				name: "immigration",
				component: enimmigration,
			}, {
				path: "goodNews",// 喜报
				name: "goodNews",
				component: engoodNews,
			}, {
				path: "goodNewsDetail",// 喜报详情
				name: "goodNewsDetail",
				component: engoodNewsDetail,
			}, {
				path: "video",// 视频
				name: "video",
				component: envideo,
			}, {
				path: "contactUs",// 联系我们
				name: "contactUs",
				component: encontactUs,
			}, {
				path: "evaluate",// 评估-配偶测评
				name: "evaluate",
				component: enevaluate,
			}, {
				path: "evaluateEoi",// 评估-eoi测评
				name: "evaluateEoi",
				component: enevaluateEoi,
			}, {
				path: "evaluateMaster",// 评估-雇主担保测评
				name: "evaluateMaster",
				component: enevaluateMaster,
			}, {
				path: "evaluateSmallStudent",// 评估-中小学留学测评
				name: "evaluateSmallStudent",
				component: enevaluateSmallStudent,
			}, {
				path: "evaluateStudent",// 评估-留学测评
				name: "evaluateStudent",
				component: enevaluateStudent,
			},
			{
				path: "bossDetail",// 人才招聘详情
				name: "bossDetail",
				component: enbossDetail,
			},
			{
				path: "toursDetail",// 游览详情
				name: "toursDetail",
				component: entoursDetail,
			}, {
				path: "diary",// 旅游日记
				name: "diary",
				component: endiary,
			}, {
				path: "diaryDetail",// 旅游日记详情
				name: "diaryDetail",
				component: endiaryDetail,
			},]
	}, {
		path: "/infoDetail",// 旅游日记详情
		name: "infoDetail",
		component: infoDetail,
	}
	],
})

// 重写 push 解决重复导航报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => {
		if (err.name !== 'NavigationDuplicated') throw err
	})
}

router.afterEach((to, from) => {
	// 如果进入的是/，则滚动到顶部
	if (to.path != '/') {
		Vue.nextTick(() => {
			try {
				window.scrollTo({
					top: 0,
					behavior: 'smooth'
				})
			} catch (e) {
				window.scrollTo(0, 0)
			}
		})
	}
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js